import { Box, Button, Stack } from '@mui/material';
import { abyssColors } from '@/theme/colors';

type FillProps = {
  variant: 'fill';
  onCancel: () => void;
  isSubmitting: boolean;
  isDirty: boolean;
};

type ViewProps = {
  variant: 'view';
  onEditJobPhase: () => void;
};

type EditSavedProps = {
  variant: 'editSaved';
  onCancel: () => void;
  onSave: () => void;
  isSubmitting: boolean;
  isDirty: boolean;
};

type Props = FillProps | ViewProps | EditSavedProps;

export const QaqcPanelFooter = (props: Props) => {
  return (
    <Box
      sx={{
        flexShrink: 0,
        borderTop: `1px solid ${abyssColors.primary[100]}`,
        px: 2,
        py: 2,
        backgroundColor: 'background.paper',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      {props.variant === 'view' ? (
        <Button
          type="button"
          variant="contained"
          size="small"
          onClick={props.onEditJobPhase}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Edit Job Phase
        </Button>
      ) : (
        <Stack direction="row" alignItems="center" gap={1}>
          <Button
            type="button"
            variant="outlined"
            size="small"
            onClick={props.onCancel}
            disabled={props.isSubmitting}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Cancel
          </Button>
          {props.variant === 'fill' ? (
            <Button
              type="submit"
              variant="contained"
              size="small"
              disabled={props.isSubmitting || !props.isDirty}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            >
              Submit
            </Button>
          ) : (
            <Button
              type="button"
              variant="contained"
              size="small"
              onClick={props.onSave}
              disabled={props.isSubmitting || !props.isDirty}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            >
              Save
            </Button>
          )}
        </Stack>
      )}
    </Box>
  );
};
